<div class="appointment">
  <div class="card">
    <div class="card-header card-no-border">
      <div class="header-top">
        <h5 class="m-0">{{ 'Valuable Customer' | translate }}</h5>
        <div class="card-header-right-icon">
          <div class="dropdown icon-dropdown">
            <button class="btn dropdown-toggle" type="button" (click)="toggle()"><app-feather-icons [icon]="'more-horizontal'"></app-feather-icons></button>
            <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">{{ 'Today' | translate }}</a><a class="dropdown-item" href="#">{{ 'Tomorrow' | translate }}</a><a class="dropdown-item" href="#">{{ 'Yesterday' | translate }}</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="appointment-table customer-table table-responsive">
        <table class="table table-bordernone">
          <tbody>
            <tr>
              <td><img class="img-fluid img-40 rounded-circle me-2" src="assets/images/dashboard/user/1.jpg" alt="user" /></td>
              <td class="img-content-box"><a class="f-w-500" href="user-profile.html">{{ 'Jane Cooper' | translate }}</a><span class="f-light">{{ 'alma.lawson&#64;gmail.com' | translate }}</span></td>
            </tr>
            <tr>
              <td><img class="img-fluid img-40 rounded-circle me-2" src="assets/images/dashboard/user/2.jpg" alt="user" /></td>
              <td class="img-content-box"><a class="f-w-500" href="user-profile.html">{{ 'Cameron Willia' | translate }}</a><span class="f-light">{{ 'tim.jennings&#64;gmail.com' | translate }}</span></td>
            </tr>
            <tr>
              <td><img class="img-fluid img-40 rounded-circle me-2" src="assets/images/dashboard/user/9.jpg" alt="user" /></td>
              <td class="img-content-box"><a class="f-w-500" href="user-profile.html">{{ 'Floyd Miles' | translate }}</a><span class="f-light">{{ 'kenzi.lawson&#64;gmail.com' | translate }}</span></td>
            </tr>
            <tr>
              <td><img class="img-fluid img-40 rounded-circle me-2" src="assets/images/dashboard/user/5.jpg" alt="user" /></td>
              <td class="img-content-box"><a class="f-w-500" href="user-profile.html">{{ 'Dianne Russell' | translate }}</a><span class="f-light">{{ 'curtis.weaver&#64;gmail.com' | translate }}</span></td>
            </tr>
            <tr>
              <td><img class="img-fluid img-40 rounded-circle me-2" src="assets/images/dashboard/user/3.jpg" alt="user" /></td>
              <td class="img-content-box"><a class="f-w-500" href="user-profile.html">{{ 'Guy Hawkins' | translate }}</a><span class="f-light">{{ 'curtis.weaver&#64;gmail.com' | translate }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
